import i18next from 'i18next';
import { SensorType, SensorUsage } from 'constants/sensors';

export const sensorTypeLiterals = {
  [SensorType.ADMIN_NUMERIC_PASSWORD]: () => i18next.t('_SENSOR_TYPE_ADMIN_NUMERIC_PASSWORD'),
  [SensorType.ALARM_CARBON_MONOXIDE]: () => i18next.t('_SENSOR_TYPE_ALARM_CARBON_MONOXIDE'),
  [SensorType.ALARM_FLOOD]: () => i18next.t('_SENSOR_TYPE_ALARM_FLOOD'),
  [SensorType.ALARM_FLOOD_CH1]: () => i18next.t('_SENSOR_TYPE_ALARM_FLOOD_CH1'),
  [SensorType.ALARM_FLOOD_CH2]: () => i18next.t('_SENSOR_TYPE_ALARM_FLOOD_CH2'),
  [SensorType.ALARM_FLOOD_CH3]: () => i18next.t('_SENSOR_TYPE_ALARM_FLOOD_CH3'),
  [SensorType.ALARM_FLOOD_CH4]: () => i18next.t('_SENSOR_TYPE_ALARM_FLOOD_CH4'),
  [SensorType.ALARM_MOTION]: () => i18next.t('_SENSOR_TYPE_ALARM_MOTION'),
  [SensorType.ALARM_MOTION_CH1]: () => i18next.t('_SENSOR_TYPE_ALARM_MOTION_CH1'),
  [SensorType.ALARM_MOTION_CH2]: () => i18next.t('_SENSOR_TYPE_ALARM_MOTION_CH2'),
  [SensorType.ALARM_MOTION_CH3]: () => i18next.t('_SENSOR_TYPE_ALARM_MOTION_CH3'),
  [SensorType.ALARM_MOTION_CH4]: () => i18next.t('_SENSOR_TYPE_ALARM_MOTION_CH4'),
  [SensorType.ALARM_SMOKE]: () => i18next.t('_SENSOR_TYPE_ALARM_SMOKE'),
  [SensorType.ALARM_TAMPER]: () => i18next.t('_SENSOR_TYPE_ALARM_TAMPER'),
  [SensorType.BATTERY]: () => i18next.t('_SENSOR_TYPE_BATTERY'),
  [SensorType.CARBON_DIOXIDE]: () => i18next.t('_SENSOR_TYPE_CARBON_DIOXIDE'),
  [SensorType.COLOR]: () => i18next.t('_SENSOR_TYPE_COLOR'),
  [SensorType.CUBICMETERS_ACCUMULATED]: () => i18next.t('_SENSOR_TYPE_CUBICMETERS_ACCUMULATED'),
  [SensorType.CUBICMETERS_HOUR]: () => i18next.t('_SENSOR_TYPE_CUBICMETERS_HOUR'),
  [SensorType.CURRENT]: () => i18next.t('_SENSOR_TYPE_CURRENT'),
  [SensorType.CURRENT_CH1]: () => i18next.t('_SENSOR_TYPE_CURRENT_CH1'),
  [SensorType.CURRENT_CH2]: () => i18next.t('_SENSOR_TYPE_CURRENT_CH2'),
  [SensorType.CURRENT_CH3]: () => i18next.t('_SENSOR_TYPE_CURRENT_CH3'),
  [SensorType.DIMMER]: () => i18next.t('_SENSOR_TYPE_DIMMER'),
  [SensorType.DOOR]: () => i18next.t('_SENSOR_TYPE_DOOR'),
  [SensorType.DOOR_CH1]: () => i18next.t('_SENSOR_TYPE_DOOR_CH1'),
  [SensorType.DOOR_CH2]: () => i18next.t('_SENSOR_TYPE_DOOR_CH2'),
  [SensorType.DOOR_CH3]: () => i18next.t('_SENSOR_TYPE_DOOR_CH3'),
  [SensorType.DOOR_CH4]: () => i18next.t('_SENSOR_TYPE_DOOR_CH4'),
  [SensorType.HUMIDITY]: () => i18next.t('_SENSOR_TYPE_HUMIDITY'),
  [SensorType.ILLUMINANCE]: () => i18next.t('_SENSOR_TYPE_ILLUMINANCE'),
  [SensorType.KILOWATTSHOUR]: () => i18next.t('_SENSOR_TYPE_KILOWATTSHOUR'),
  [SensorType.KILOWATTSHOUR_ACCUMULATED]: () => i18next.t('_SENSOR_TYPE_KILOWATTSHOUR_ACCUMULATED'),
  [SensorType.KILOWATTSHOUR_ACCUMULATED_CH1]: () => i18next.t('_SENSOR_TYPE_KILOWATTSHOUR_ACCUMULATED_CH1'),
  [SensorType.KILOWATTSHOUR_ACCUMULATED_CH2]: () => i18next.t('_SENSOR_TYPE_KILOWATTSHOUR_ACCUMULATED_CH2'),
  [SensorType.KILOWATTSHOUR_ACCUMULATED_CH3]: () => i18next.t('_SENSOR_TYPE_KILOWATTSHOUR_ACCUMULATED_CH3'),
  [SensorType.KILOWATTSHOUR_HOUR_CH1]: () => i18next.t('_SENSOR_TYPE_KILOWATTSHOUR_HOUR_CH1'),
  [SensorType.KILOWATTSHOUR_HOUR_CH2]: () => i18next.t('_SENSOR_TYPE_KILOWATTSHOUR_HOUR_CH2'),
  [SensorType.KILOWATTSHOUR_HOUR_CH3]: () => i18next.t('_SENSOR_TYPE_KILOWATTSHOUR_HOUR_CH3'),
  [SensorType.LITERS_ACCUMULATED]: () => i18next.t('_SENSOR_TYPE_LITERS_ACCUMULATED'),
  [SensorType.LITERS_HOUR]: () => i18next.t('_SENSOR_TYPE_LITERS_HOUR'),
  [SensorType.LOCK]: () => i18next.t('_SENSOR_TYPE_LOCK'),
  [SensorType.LOCK_3_POSITIONS]: () => i18next.t('_SENSOR_TYPE_LOCK_3_POSITIONS'),
  [SensorType.LUMEN]: () => i18next.t('_SENSOR_TYPE_LUMEN'),
  [SensorType.LUX]: () => i18next.t('_SENSOR_TYPE_LUX'),
  [SensorType.NFC_CODE]: () => i18next.t('_SENSOR_TYPE_NFC_CODE'),
  [SensorType.NUMERIC_PASSWORD]: () => i18next.t('_SENSOR_TYPE_NUMERIC_PASSWORD'),
  [SensorType.PARTICULATE_MATTER25]: () => i18next.t('_SENSOR_TYPE_PARTICULATE_MATTER25'),
  [SensorType.PEOPLE_COUNTER]: () => i18next.t('_SENSOR_TYPE_PEOPLE_COUNTER'),
  [SensorType.PEOPLE_FLOW_IN]: () => i18next.t('_SENSOR_TYPE_PEOPLE_FLOW_IN'),
  [SensorType.PEOPLE_FLOW_OUT]: () => i18next.t('_SENSOR_TYPE_PEOPLE_FLOW_OUT'),
  [SensorType.POWERFACTOR]: () => i18next.t('_SENSOR_TYPE_POWERFACTOR'),
  [SensorType.POWERFACTOR_CH1]: () => i18next.t('_SENSOR_TYPE_POWERFACTOR_CH1'),
  [SensorType.POWERFACTOR_CH2]: () => i18next.t('_SENSOR_TYPE_POWERFACTOR_CH2'),
  [SensorType.POWERFACTOR_CH3]: () => i18next.t('_SENSOR_TYPE_POWERFACTOR_CH3'),
  [SensorType.PUSHBUTTON]: () => i18next.t('_SENSOR_TYPE_PUSHBUTTON'),
  [SensorType.QR_CODE]: () => i18next.t('_SENSOR_TYPE_QR_CODE'),
  [SensorType.SHUTTER]: () => i18next.t('_SENSOR_TYPE_SHUTTER'),
  [SensorType.SLATS]: () => i18next.t('_SENSOR_TYPE_SLATS'),
  [SensorType.SWITCH]: () => i18next.t('_SENSOR_TYPE_SWITCH'),
  [SensorType.SWITCH_CH1]: () => i18next.t('_SENSOR_TYPE_SWITCH_CH1'),
  [SensorType.SWITCH_CH2]: () => i18next.t('_SENSOR_TYPE_SWITCH_CH2'),
  [SensorType.SWITCH_CH3]: () => i18next.t('_SENSOR_TYPE_SWITCH_CH3'),
  [SensorType.SWITCH_CH4]: () => i18next.t('_SENSOR_TYPE_SWITCH_CH4'),
  [SensorType.TEMPERATURE]: () => i18next.t('_SENSOR_TYPE_TEMPERATURE'),
  [SensorType.TEMPERATURE_CH1]: () => i18next.t('_SENSOR_TYPE_TEMPERATURE_CH1'),
  [SensorType.TEMPERATURE_CH2]: () => i18next.t('_SENSOR_TYPE_TEMPERATURE_CH2'),
  [SensorType.TEMPERATURE_CH3]: () => i18next.t('_SENSOR_TYPE_TEMPERATURE_CH3'),
  [SensorType.TEMPERATURE_CH4]: () => i18next.t('_SENSOR_TYPE_TEMPERATURE_CH4'),
  [SensorType.THERMOSTAT_FAN_MODE]: () => i18next.t('_SENSOR_TYPE_THERMOSTAT_FAN_MODE'),
  [SensorType.THERMOSTAT_MODE]: () => i18next.t('_SENSOR_TYPE_THERMOSTAT_MODE'),
  [SensorType.THERMOSTAT_OPERATING_STATE]: () => i18next.t('_SENSOR_TYPE_THERMOSTAT_OPERATING_STATE'),
  [SensorType.THERMOSTAT_SETPOINT]: () => i18next.t('_SENSOR_TYPE_THERMOSTAT_SETPOINT'),
  [SensorType.THERMOSTAT_SETPOINT_COOLING]: () => i18next.t('_SENSOR_TYPE_THERMOSTAT_SETPOINT_COOLING'),
  [SensorType.THERMOSTAT_SETPOINT_HEATING]: () => i18next.t('_SENSOR_TYPE_THERMOSTAT_SETPOINT_HEATING'),
  [SensorType.VIRTUAL_PRESENCE]: () => i18next.t('_SENSOR_TYPE_VIRTUAL_PRESENCE'),
  [SensorType.VOLATILE_ORGANIC_COMPOUND]: () => i18next.t('_SENSOR_TYPE_VOLATILE_ORGANIC_COMPOUND'),
  [SensorType.VOLTAGE]: () => i18next.t('_SENSOR_TYPE_VOLTAGE'),
  [SensorType.VOLTAGE_CH1]: () => i18next.t('_SENSOR_TYPE_VOLTAGE_CH1'),
  [SensorType.VOLTAGE_CH2]: () => i18next.t('_SENSOR_TYPE_VOLTAGE_CH2'),
  [SensorType.VOLTAGE_CH3]: () => i18next.t('_SENSOR_TYPE_VOLTAGE_CH3'),
  [SensorType.WATTS]: () => i18next.t('_SENSOR_TYPE_WATTS'),
  [SensorType.WATTS_INSTANTANEOUS_CH1]: () => i18next.t('_SENSOR_TYPE_WATTS_INSTANTANEOUS_CH1'),
  [SensorType.WATTS_INSTANTANEOUS_CH2]: () => i18next.t('_SENSOR_TYPE_WATTS_INSTANTANEOUS_CH2'),
  [SensorType.WATTS_INSTANTANEOUS_CH3]: () => i18next.t('_SENSOR_TYPE_WATTS_INSTANTANEOUS_CH3'),
  [SensorType.WIFI]: () => i18next.t('_SENSOR_TYPE_WIFI'),
};

export const sensorUsageLiterals = {
  [SensorUsage.AC]: () => i18next.t('_SENSOR_USAGE_AC'),
  [SensorUsage.ALARM]: () => i18next.t('_SENSOR_USAGE_ALARM'),
  [SensorUsage.ALARM_ENABLE]: () => i18next.t('_SENSOR_USAGE_ALARM_ENABLE'),
  [SensorUsage.BOILER]: () => i18next.t('_SENSOR_USAGE_BOILER'),
  [SensorUsage.COMMUNITY_DOOR]: () => i18next.t('_SENSOR_USAGE_COMMUNITY_DOOR'),
  [SensorUsage.DOOR]: () => i18next.t('_SENSOR_USAGE_DOOR'),
  [SensorUsage.DOORBELL]: () => i18next.t('_SENSOR_USAGE_DOORBELL'),
  [SensorUsage.EXTRACTOR]: () => i18next.t('_SENSOR_USAGE_EXTRACTOR'),
  [SensorUsage.FAN]: () => i18next.t('_SENSOR_USAGE_FAN'),
  [SensorUsage.FIRE]: () => i18next.t('_SENSOR_USAGE_FIRE'),
  [SensorUsage.FLOOD]: () => i18next.t('_SENSOR_USAGE_FLOOD'),
  [SensorUsage.HOME_APPLIANCES]: () => i18next.t('_SENSOR_USAGE_HOME_APPLIANCES'),
  [SensorUsage.INFO_SENSOR]: () => i18next.t('_SENSOR_USAGE_INFO_SENSOR'),
  [SensorUsage.LIGHT]: () => i18next.t('_SENSOR_USAGE_LIGHT'),
  [SensorUsage.LOCAL]: () => i18next.t('_SENSOR_USAGE_LOCAL'),
  [SensorUsage.MOTION]: () => i18next.t('_SENSOR_USAGE_MOTION'),
  [SensorUsage.PUMP]: () => i18next.t('_SENSOR_USAGE_PUMP'),
  [SensorUsage.REMOTE]: () => i18next.t('_SENSOR_USAGE_REMOTE'),
  [SensorUsage.ROLLER]: () => i18next.t('_SENSOR_USAGE_ROLLER'),
  [SensorUsage.SIREN]: () => i18next.t('_SENSOR_USAGE_SIREN'),
  [SensorUsage.SLATS]: () => i18next.t('_SENSOR_USAGE_SLATS'),
  [SensorUsage.SOCKET]: () => i18next.t('_SENSOR_USAGE_SOCKET'),
  [SensorUsage.SWITCH]: () => i18next.t('_SENSOR_USAGE_SWITCH'),
  [SensorUsage.VALVE_GAS]: () => i18next.t('_SENSOR_USAGE_VALVE_GAS'),
  [SensorUsage.VALVE_UNDERFLOOR_HEATING]: () => i18next.t('_SENSOR_USAGE_VALVE_UNDERFLOOR_HEATING'),
  [SensorUsage.VALVE_WATER]: () => i18next.t('_SENSOR_USAGE_VALVE_WATER'),
  [SensorUsage.WINDOW]: () => i18next.t('_SENSOR_USAGE_WINDOW'),
};
